import React from 'react'
import { Request2Estes } from "../../../../../Templates/components/APIs";

const GET_SCHD_CLASS_STD_NEXT = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_SCHD_CLASS_STD_NEXT",
    };
    const results = await Request2Estes(param_post);

    return results;
};

const GET_SECTION = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_SECTION",
    };
    const results = await Request2Estes(param_post);

    return results;
};

export {GET_SCHD_CLASS_STD_NEXT, GET_SECTION}